import React, { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { lang } from "../../../middleware/lang";
import { LoaderDots } from "../../../middleware/loaders";
import { HeaderTitle } from "../common/titles";
import { has_access } from "../../../middleware/privileges";
import { GET_SUPPLIERS } from "./queries";
import { Supplier } from "./models";
import InventoryNav from "./inventoryNav";

const btn = {
  txt: lang("Nuevo Proveedor", "New Supplier"),
  icon: "fa fa-plus",
  link: "/inventory/suppliers/new",
};

const SupplierList: React.FC = () => {
  const history = useHistory();
  const [search, setSearch] = useState("");

  const [fetchSuppliers, { data, loading }] = useLazyQuery(GET_SUPPLIERS, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    fetchSuppliers({
      variables: { search: search || undefined, take: 100 },
    });
    //eslint-disable-next-line
  }, [search]);

  return (
    <>
      <HeaderTitle
        title={lang("Proveedores", "Suppliers")}
        btn={has_access(256) ? btn : null}
      />
      <InventoryNav active="suppliers" />

      <div className="row mb-3">
        <div className="col-lg-4">
          <input
            type="text"
            className="form-control"
            placeholder={lang("Buscar proveedor...", "Search supplier...")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {loading && <LoaderDots fullSize />}

      {data && (
        <div className="row">
          <div className="col-lg-12">
            <div className="material_card p-3 table-responsive">
              <table className="table table-hover vertical_middle">
                <thead className="thead-light">
                  <tr>
                    <th>{lang("Nombre", "Name")}</th>
                    <th>{lang("Contacto", "Contact")}</th>
                    <th>{lang("Teléfono", "Phone")}</th>
                    <th>{lang("Email", "Email")}</th>
                    <th>{lang("Ingredientes", "Ingredients")}</th>
                    <th>{lang("Estado", "Status")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.getSuppliers.map((supplier: Supplier) => (
                    <tr
                      key={supplier.id}
                      className="cursor-pointer"
                      onClick={() =>
                        history.push(`/inventory/suppliers/edit/${supplier.id}`)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <td className="font-weight-bold">{supplier.name}</td>
                      <td>{supplier.contact_name || "—"}</td>
                      <td>
                        <small>{supplier.phone || "—"}</small>
                      </td>
                      <td>
                        <small>{supplier.email || "—"}</small>
                      </td>
                      <td>
                        <span className="badge badge-info">
                          {supplier.ingredients?.length || 0}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge badge-${
                            supplier.status ? "success" : "secondary"
                          }`}
                        >
                          {supplier.status
                            ? lang("Activo", "Active")
                            : lang("Inactivo", "Inactive")}
                        </span>
                      </td>
                    </tr>
                  ))}
                  {data.getSuppliers.length === 0 && (
                    <tr>
                      <td colSpan={6} className="text-center text-muted py-4">
                        {lang(
                          "No hay proveedores registrados",
                          "No suppliers registered"
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SupplierList;
